import config from "../../../config";

export const getDiscoverCollection = () => {
    return {
        "All": {
            collection: "All",
            cta_url: "https://shop.rebag.com/collections/new-arrivals?sort=created-descending",
            products: [
                {
                    vendor: "Louis Vuitton",
                    title: "Neverfull Tote",
                    img: "neverfull-tote.png",
                    url: "https://shop.rebag.com/collections/louis-vuitton?pf_t_categories=bc-filter-Bags&pf_t_model=meta-model-neverfull-nm-tote&pf_t_model=meta-model-neverfull-tote",
                },
                {
                    vendor: "Rolex",
                    title: "Oyster Perpetual Datejust",
                    img: "oyster-perpetual-datejust.png",
                    url: "https://shop.rebag.com/search?q=Rolex+Oyster+Perpetual+Datejust&sort=extra-sort2-ascending",
                },
                {
                    vendor: "Chanel",
                    title: "Classic Flap Bag",
                    img: "classic-flap-bag.png",
                    url: "https://shop.rebag.com/collections/chanel?pf_t_categories=bc-filter-Bags&pf_t_model=meta-model-classic-double-flap-bag&pf_t_model=meta-model-classic-single-flap-bag",
                },
                {
                    vendor: "Van Cleef & Arpels",
                    title: "Alhambra Necklace",
                    img: "alhambra-necklace.png",
                    url: "https://shop.rebag.com/search?q=Van+Cleef+%26+Arpels+Alhambra+Necklace+&sort=extra-sort2-ascending",
                },
                {
                    vendor: "Christian Dior",
                    title: "Lady Dior Bag",
                    img: "lady-dior-bag.png",
                    url: "https://shop.rebag.com/collections/christian-dior?pf_t_categories=bc-filter-Bags&pf_t_model=meta-model-lady-dior-bag",
                },
                {
                    vendor: "Cartier",
                    title: "Love Bracelet",
                    img: "love-bracelet.png",
                    url: "https://shop.rebag.com/search?q=cartier+love+bracelet&sort=extra-sort2-ascending",
                },
                {
                    vendor: "Fendi",
                    title: "Baguette Bag",
                    img: "baguette-bag.png",
                    url: "https://shop.rebag.com/collections/fendi?pf_t_categories=bc-filter-Bags&pf_t_model=meta-model-baguette-nm-bag",
                },
                {
                    vendor: "Hermès",
                    title: "Kelly Bag",
                    img: "kelly-bag.png",
                    url: "https://shop.rebag.com/collections/hermes?pf_t_categories=bc-filter-Bags&pf_t_model=meta-model-kelly-handbag",
                },
                {
                    vendor: "Hermès",
                    title: "Birkin Bag",
                    img: "birkin-bag.png",
                    url: "https://shop.rebag.com/collections/hermes?pf_t_categories=bc-filter-Bags&pf_t_model=meta-model-birkin-handbag",
                },
                {
                    vendor: "Rolex",
                    title: "Oyster Perpetual Submariner",
                    img: "oyster-perpetual-submariner.png",
                    url: "https://shop.rebag.com/search?q=rolex+oyster+perpetual+submariner&sort=extra-sort2-ascending",
                },
                {
                    vendor: "Louis Vuitton",
                    title: "OnTheGo Tote",
                    img: "onthego-tote.png",
                    url: "https://shop.rebag.com/collections/louis-vuitton?pf_t_categories=bc-filter-Bags&pf_t_model=meta-model-onthego-tote",
                },
                {
                    vendor: "Cartier",
                    title: "Juste un Clou Bracelet",
                    img: "juste-un-clou-bracelet.png",
                    url: "https://shop.rebag.com/search?q=Cartier+Juste+Un+Clou+Bracelet&sort=extra-sort2-ascending",
                },
            ]
        },
        "Bags": {
            collection: "Bags",
            cta_url: "https://shop.rebag.com/collections/all-bags",
            products: [
                {
                    vendor: "Prada",
                    title: "Cleo Bag",
                    img: "cleo-bag.png",
                    url: "https://shop.rebag.com/search?q=Prada++Cleo+Bag&sort=extra-sort2-ascending",
                },
                {
                    vendor: "Hermès",
                    title: "Birkin Bag",
                    img: "birkin-bag.png",
                    url: "https://shop.rebag.com/collections/hermes?pf_t_categories=bc-filter-Bags&pf_t_model=meta-model-birkin-handbag",
                },
                {
                    vendor: "Bottega Veneta",
                    title: "Andiamo Bag",
                    img: "andiamo-bag.png",
                    url: "https://shop.rebag.com/search?q=Bottega+Veneta+Andiamo+Bag&sort=extra-sort2-ascending",
                },
                {
                    vendor: "Goyard",
                    title: "Saint Louis Tote",
                    img: "saint-louis-tote.png",
                    url: "https://shop.rebag.com/search?q=Goyard++Saint+Louis+Tote&sort=extra-sort2-ascending",
                },
                {
                    vendor: "Hermès",
                    title: "Kelly Bag",
                    img: "kelly-bag.png",
                    url: "https://shop.rebag.com/collections/hermes?pf_t_categories=bc-filter-Bags&pf_t_model=meta-model-kelly-handbag",
                },
                {
                    vendor: "Gucci",
                    title: "Jackie 1961 Hobo",
                    img: "jackie-1961-hobo.png",
                    url: "https://shop.rebag.com/search?q=Gucci+Jackie+1961+Hobo&sort=extra-sort2-ascending",
                },
                {
                    vendor: "Louis Vuitton",
                    title: "OnTheGo Tote",
                    img: "onthego-tote.png",
                    url: "https://shop.rebag.com/collections/louis-vuitton?pf_t_categories=bc-filter-Bags&pf_t_model=meta-model-onthego-tote",
                },
                {
                    vendor: "Celine",
                    title: "Triomphe Bag",
                    img: "triomphe-bag.png",
                    url: "https://shop.rebag.com/search?q=Celine++Triomphe+Bag&sort=extra-sort2-ascending",
                },
                {
                    vendor: "Louis Vuitton",
                    title: "Neverfull Tote",
                    img: "neverfull-tote.png",
                    url: "https://shop.rebag.com/collections/louis-vuitton?pf_t_categories=bc-filter-Bags&pf_t_model=meta-model-neverfull-nm-tote&pf_t_model=meta-model-neverfull-tote",
                },
                {
                    vendor: "Chanel",
                    title: "Classic Flap Bag",
                    img: "classic-flap-bag.png",
                    url: "https://shop.rebag.com/collections/chanel?pf_t_categories=bc-filter-Bags&pf_t_model=meta-model-classic-double-flap-bag&pf_t_model=meta-model-classic-single-flap-bag",
                },
                {
                    vendor: "Christian Dior",
                    title: "Lady Dior Bag",
                    img: "lady-dior-bag.png",
                    url: "https://shop.rebag.com/collections/christian-dior?pf_t_categories=bc-filter-Bags&pf_t_model=meta-model-lady-dior-bag",
                },
                {
                    vendor: "Fendi",
                    title: "Baguette Bag",
                    img: "baguette-bag.png",
                    url: "https://shop.rebag.com/collections/fendi?pf_t_categories=bc-filter-Bags&pf_t_model=meta-model-baguette-nm-bag",
                },
            ]
        },
        "Jewelry": {
            collection: "Jewelry",
            cta_url: "https://shop.rebag.com/collections/all-jewelry",
            products: [
                {
                    vendor: "Van Cleef & Arpels",
                    title: "Alhambra Necklace",
                    img: "alhambra-necklace.png",
                    url: "https://shop.rebag.com/search?q=Van+Cleef+%26+Arpels+Alhambra+Necklace+&sort=extra-sort2-ascending",
                },
                {
                    vendor: "Tiffany & Co.",
                    title: "HardWear Link Bracelet",
                    img: "hardwear-link-bracelet.png",
                    url: "https://shop.rebag.com/search?q=Tiffany+%26+Co.++HardWear+Link+Bracelet&sort=extra-sort2-ascending",
                },
                {
                    vendor: "Van Cleef & Arpels",
                    title: "Vintage Alhambra 10 Motifs Necklace",
                    img: "vintage-alhambra-10-motifs-necklace.png",
                    url: "https://shop.rebag.com/search?q=Van+Cleef+%26+Arpels+Vintage+Alhambra+10+Motifs+Necklace&sort=extra-sort2-ascending",
                },
                {
                    vendor: "Cartier",
                    title: "Juste un Clou Bracelet",
                    img: "juste-un-clou-bracelet.png",
                    url: "https://shop.rebag.com/search?q=Cartier+Juste+Un+Clou+Bracelet&sort=extra-sort2-ascending",
                },
                {
                    vendor: "Cartier",
                    title: "Juste un Clou Double Ring",
                    img: "juste-un-clou-double-ring.png",
                    url: "https://shop.rebag.com/search?q=Cartier++Juste+un+Clou+Double+Ring&sort=extra-sort2-ascending",
                },
                {
                    vendor: "Cartier",
                    title: "Love 10 Diamond Bracelet",
                    img: "love-10-diamond-bracelet.png",
                    url: "https://shop.rebag.com/search?q=Cartier++Love+10+Diamond+Bracelet&sort=extra-sort2-ascending",
                },
                {
                    vendor: "Van Cleef & Arpels",
                    title: "Vintage Alhambra Earrings",
                    img: "vintage-alhambra-earrings.png",
                    url: "https://shop.rebag.com/search?q=Van+Cleef+%26+Arpels+Vintage+Alhambra+Earrings&sort=extra-sort2-ascending",
                },
                {
                    vendor: "Tiffany & Co.",
                    title: "T Wire Bracelet",
                    img: "t-wire-bracelet.png",
                    url: "https://shop.rebag.com/search?q=Tiffany+%26+Co.++T+Wire+Bracelet&sort=extra-sort2-ascending",
                },
                {
                    vendor: "Cartier",
                    title: "Love Wedding Band",
                    img: "love-wedding-band.png",
                    url: "https://shop.rebag.com/search?q=Cartier++Love+Wedding+Band&sort=extra-sort2-ascending",
                },
                {
                    vendor: "Van Cleef & Arpels",
                    title: "Vintage Alhambra 5 Motifs Bracelet",
                    img: "vintage-alhambra-5-motifs-bracelet.png",
                    url: "https://shop.rebag.com/search?q=Van+Cleef+%26+Arpels+Vintage+Alhambra+5+Motifs+Bracelet&sort=extra-sort2-ascending",
                },
                {
                    vendor: "Cartier",
                    title: "Love Interlocking Necklace",
                    img: "love-interlocking-necklace.png",
                    url: "https://shop.rebag.com/search?q=Cartier++Love+Interlocking+Necklace&sort=extra-sort2-ascending",
                },
                {
                    vendor: "Cartier",
                    title: "Love Bracelet",
                    img: "love-bracelet.png",
                    url: "https://shop.rebag.com/search?q=cartier+love+bracelet&sort=extra-sort2-ascending",
                },
            ]
        },
        "Watches": {
            collection: "Watches",
            cta_url: "https://shop.rebag.com/collections/all-watches",
            products: [
                {
                    vendor: "Rolex",
                    title: "Oyster Perpetual Datejust",
                    img: "oyster-perpetual-datejust.png",
                    url: "https://shop.rebag.com/search?q=Rolex+Oyster+Perpetual+Datejust&sort=extra-sort2-ascending",
                },
                {
                    vendor: "Cartier",
                    title: "Tank Watch",
                    img: "tank-watch.png",
                    url: "https://shop.rebag.com/search?q=Cartier++Tank+Watch&sort=extra-sort2-ascending ",
                },
                {
                    vendor: "Rolex",
                    title: "Oyster Perpetual Submariner",
                    img: "oyster-perpetual-submariner.png",
                    url: "https://shop.rebag.com/search?q=rolex+oyster+perpetual+submariner&sort=extra-sort2-ascending",
                },
                {
                    vendor: "Cartier",
                    title: "Santos Watch",
                    img: "santos-watch.png",
                    url: "https://shop.rebag.com/search?q=Cartier+Santos+Watch&sort=extra-sort2-ascending",
                },
                {
                    vendor: "Rolex",
                    title: "Oyster Perpetual Sea-Dweller",
                    img: "oyster-perpetual-sea-dweller.png",
                    url: "https://shop.rebag.com/search?q=Rolex+Oyster+Perpetual+Sea-Dweller&sort=extra-sort2-ascending",
                },
                {
                    vendor: "Bvlgari",
                    title: "Serpenti Tubogas Watch",
                    img: "serpenti-tubogas-watch.png",
                    url: "https://shop.rebag.com/search?q=Bvlgari+Serpenti+Tubogas+Watch&sort=extra-sort2-ascending",
                },
                {
                    vendor: "Cartier",
                    title: "Ballon Bleu de Cartier Watch",
                    img: "ballon-bleu-de-cartier-watch.png",
                    url: "https://shop.rebag.com/search?q=Cartier+Ballon+Bleu+de+Cartier+Watch&sort=extra-sort2-ascending",
                },
                {
                    vendor: "Rolex",
                    title: "Oyster Perpetual Yacht-Master II",
                    img: "oyster-perpetual-yacht-master.png",
                    url: "https://shop.rebag.com/search?q=Rolex+Oyster+Perpetual+Yacht-Master+II&sort=extra-sort2-ascending",
                },
                {
                    vendor: "Rolex",
                    title: "Oyster Perpetual Date GMT-Master II",
                    img: "oyster-perpetual-date-gmt-master.png",
                    url: "https://shop.rebag.com/search?q=Rolex+Oyster+Perpetual+Date+GMT-Master+II+&sort=extra-sort2-ascending",
                },
                {
                    vendor: "Omega",
                    title: "Speedmaster Watch",
                    img: "speedmaster-watch.png",
                    url: "https://shop.rebag.com/search?q=Omega+Speedmaster+Watch&sort=extra-sort2-ascending",
                },
                {
                    vendor: "Cartier",
                    title: "Panthère de Cartier Watch",
                    img: "panthere-de-cartier-watch.png",
                    url: "https://shop.rebag.com/search?q=Cartier++Panth%C3%A8re+de+Cartier+Watch&sort=extra-sort2-ascending",
                },
                {
                    vendor: "Omega",
                    title: "Seamaster Watch",
                    img: "seamaster-watch.png",
                    url: "https://shop.rebag.com/search?q=Omega++Seamaster+Watch&sort=extra-sort2-ascending",
                },
            ]
        }
    }
}

export const getHomeShopCollection = () => {
    return {
        bags_link:  `${config.host_rebag_shop}/collections/all-bags?sort=extra-sort1-descending`,
        accessories_link: `${config.host_rebag_shop}/collections/all-accessories?sort=extra-sort1-descending`,
        jewelry_link: `${config.host_rebag_shop}/collections/all-jewelry?sort=extra-sort1-descending`,
        watches_link: `${config.host_rebag_shop}/collections/all-watches?sort=extra-sort1-descending`,
        shoes_link: `${config.host_rebag_shop}/collections/all-shoes?sort=extra-sort1-descending`,
        apparel_link: `${config.host_rebag_shop}/collections/all-apparel?sort=extra-sort1-descending`,
    }
}

export const getResponsiveSettings = () => {
    return [
        // desktop big:
        {
            breakpoint: 1300,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
            }
        },
        // desktop:
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
            }
        },
        // tablet:
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
            }
        },
        // mobile:
        {
            breakpoint: 540,
            settings: {
                slidesToShow: 1.5,
                slidesToScroll: 1,
            }
        },
    ];
}